import { DateLib, DateLibOptions } from "react-day-picker";

export const getWeekdayNameFormat = (
  weekday: Date,
  options?: DateLibOptions,
) => {
  return new DateLib(options).format(weekday, "ccc");
};
